import React from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { isMobile } from 'utils/environment';

import { MainFab } from './main-fab';

export const FabContainer: React.FC = () => {
  const enableMainFabButton = useFlag(LaunchDarklyFlag.ENABLE_MAIN_FAB_BUTTON);

  const shouldRender = enableMainFabButton && isMobile();

  return shouldRender ? <MainFab /> : null;
};
